<template>
<div class="badge-wrap">
    <div class="label"> {{ badge.bgd_name }}</div>
    <div 
        class="img-wrap"
        @click="emitClickedBadge"
        @mouseenter="toggleHovering"
        @mouseleave="toggleHovering"
    >
        <img
            :class="{ 'is-active' : badge.active || isOnAdminPanel }"
            :src="badgeImageURL" 
            alt="user-badge.jpg"
        >
        <img 
            v-if="showDelete" 
            class="x" 
            :src="$images.plus" 
            alt="delete-button"
            @click.stop="$emit('delete-badge', badge)"
        >
        <transition name="arrow">
            <div 
                v-if="showDesc && badge.bgd_desc"
                class="tooltip"
            >
                {{ badge.bgd_desc }}
            </div>
        </transition>
    </div>
</div>
</template>

<script>
export default {
    props: {
        badge: {
            type: Object,
            required: true,
        },
    },
    emits: [
        'badge',
        'delete-badge',
    ],
    data () {
        return {
            showDelete: false,
            showDesc: false,
        };
    },
    computed: {
        badgeImageURL() {
            const sid = localStorage.getItem('sid');
            return process.env.VUE_APP_API_URL+`/badges/image?bgd_id=${this.badge.bgd_id}&sid=${sid}`;
        },
        isOnAdminPanel () {
          return this.$route.fullPath.includes('/admin');
        },
    },
    methods: {
        emitClickedBadge () {
            if (this.isOnAdminPanel) this.$emit('badge', this.badge);
        },
        toggleHovering () {
            if (this.isOnAdminPanel) this.showDelete = !this.showDelete;
            if (!this.isOnAdminPanel) this.showDesc = !this.showDesc;
        },
    },
}
</script>

<style lang="scss" scoped>
$imgSize: 130px;

.badge-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
    .label {
        max-width: $imgSize;
        font-weight: 600;
        color: #001529;
    }
    .img-wrap {
        position: relative;
        width: $imgSize;
        max-width: $imgSize;
        height: $imgSize;
        max-height: $imgSize;
        margin-top: 5px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          /* Chrome, Safari */
          -webkit-filter: grayscale(1);
          /* Firefox */
          filter: grayscale(1);
          opacity: .4;
          &.is-active {
            opacity: 1;
            -webkit-filter: none;
            filter: none;
          }
        }
    }
    .x {
        position: absolute;
        top: 3px;
        right: 3px;
        filter: brightness(.6);
        transform: rotate(45deg);
        cursor: pointer;
        max-width: 20px;
        max-height: 20px;
    }
    .tooltip {
        position: absolute;
        bottom: calc(100% + 2em);
        right: 50%;
        transform: translate(50%);
        background: black;
        border-radius: 10px;
        padding: .5em;
        color: #FFF;
        font-weight: 600;
        width: max-content;
        max-width: 250%;
        
    }

}

.arrow-enter-active,
.arrow-leave-active {
    transition: opacity 0.3s;
}
.arrow-enter,
.arrow-leave-to {
    opacity: 0;
}
</style>